import React, { useState } from 'react';
import { useAtomValue } from 'jotai';
import { PopupOverlay } from '@src/components/PopupOverlay';
import { EPopup } from '@src/types/common';
import { ActionButton } from '@src/components/ActionButton';
import { Loader } from '@src/components/Loader';
import { stylesheet } from 'typestyle';
import { popupsAtom, setPopup } from '@src/state/popupAtoms';

export default function PromptConfirm() {
  const [loading, setLoading] = useState(false);
  const data = useAtomValue(popupsAtom)[EPopup.promptconfirm];

  const close = () => setPopup(EPopup.promptconfirm, null);

  const onAnswer = (yes: boolean) => {
    setLoading(true);
    Promise.resolve(data!.answer(yes))
      .catch(e => { throw e; })
      .then(() => {
        setLoading(false);
        close();
      });
  };

  if (!data) return null;
  const text = data.text || {};
  const yesColor = data.yesColor || 'blue';

  return (
    <PopupOverlay show={!!data} onClose={() => onAnswer(false)} title={data.question} width="min(420px, 92vw)" zIndex={2000}>
      {!loading ? (
        <div className={sheet.answers}>
          <div>
            <ActionButton variant="transparent" onAction={() => onAnswer(false)}>
              {(text.no || window.T('common.prompt.no')).toUpperCase()}
            </ActionButton>
          </div>
          <div>
            <ActionButton variant={yesColor} onAction={() => onAnswer(true)}>
              {(text.yes || window.T('common.prompt.yes')).toUpperCase()}
            </ActionButton>
          </div>
        </div>
      ) : (
        <div className={sheet.loader}><Loader size={40} /></div>
      )}
    </PopupOverlay>
  );
}

const sheet = stylesheet({
  answers: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: 14,
  },
  loader: { textAlign: 'center', marginTop: 4 },
});

